import React, { Fragment, useState, useEffect } from "react";
import timeZoneList from "../../../../../../data/timeZoneList";
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import { CardBody, Button, Card, CustomInput, Input, Label } from "reactstrap";
import { Colxx, Separator } from '../../../../../../components/common/CustomBootstrap';
import grid_layout from '../../images/grid_layout.png';
import collage_layout from '../../images/collage_layout.png';
import masoonary_layout from '../../images/masoonary_layout.png';
import column_layout from '../../images/column_layout.png';
import pro_layout from '../../images/pro_layout_image.png';
import slideshow_layout from '../../images/slideshow_layout.png';
import slider_layout from '../../images/slider_layout.png';
import thumbnail_layout from '../../images/thumbnail_layout.png';
import paranoma_layout from '../../images/paranoma_layout.png';
import custom_layout from '../../images/custom_layout.png';
import mobile_layout from '../../images/mobile_layout.jpg';

const StandaloneLayout = ({ pageSettings, saveIntegration, country, propertyData }) => {
    const [timeZone, setTimeZone] = useState([]);
    const [layout, setLayout] = useState(pageSettings !== undefined && pageSettings !== null
        &&
        pageSettings);
    const handleBack = () => {
        // setLiveChat(liveChatSettings !== undefined && liveChatSettings !== null
        //     ?
        //     liveChatSettings :
        //     {
        //         enabled: false,
        //         displayRule: '3',
        //         outSideIndicator: false,
        //         businessHours: {
        //             timeZone: propertyData.timeZone,
        //             time: [{
        //                 id: 1,
        //                 hourFrom: '0',
        //                 hourTo: '1',
        //                 day: ''
        //             }]
        //         }
        //     });
    };




    const handleSave = () => {
        console.log(layout);
        saveIntegration({ pageSettings: layout });
    };
    return (
        <Fragment>
            <Card className="mb-4">
                <CardBody className="mb-2">
                    <div className="text-center mb-2">
                        <h3>Layout</h3>
                    </div>
                    <Separator className="mt-2 mb-2" />
                    <div className=" row ml-2">
                        <div className="col-md-4 my-1">
                            <CustomInput
                                type="radio"
                                name='displayRule'
                                checked={layout.layoutType === 0 ? true : false}
                                onChange={event => {
                                    setLayout({ ...layout, layoutType: 0 })
                                }}
                            >
                                <img className="layout-image" src={collage_layout}></img>
                                <span className="d-flex justify-content-left ml-2">Collage Layout</span>
                            </CustomInput>
                        </div>
                        <div className="col-md-4 my-1">
                            <CustomInput
                                type="radio"
                                name='displayRule'
                                checked={layout.layoutType === 1 ? true : false}
                                onChange={event => {
                                    setLayout({ ...layout, layoutType: 1 })
                                }}
                            >
                                <img className="layout-image" src={masoonary_layout}></img>
                                <span className="d-flex justify-content-left ml-2">Masonry Layout</span>
                            </CustomInput>
                        </div>
                        <div className="col-md-4 my-1">
                            <CustomInput
                                type="radio"
                                name='displayRule'
                                checked={layout.layoutType === 2 ? true : false}
                                onChange={event => {
                                    setLayout({ ...layout, layoutType: 2 })
                                }}
                            >
                                <img className="layout-image" src={grid_layout}></img>
                                <span className="d-flex justify-content-left ml-2">Grid Layout</span>
                            </CustomInput>
                        </div>
                        <div className="col-md-4 my-1">
                            <CustomInput
                                type="radio"
                                name='displayRule'
                                checked={layout.layoutType === 3 ? true : false}
                                onChange={event => {
                                    setLayout({ ...layout, layoutType: 3 })
                                }}
                            >
                                <img className="layout-image" src={thumbnail_layout}></img>
                                <span className="d-flex justify-content-left ml-2">Thumbnails Layout</span>
                            </CustomInput>
                        </div>
                        <div className="col-md-4 my-1">
                            <CustomInput
                                type="radio"
                                name='displayRule'
                                checked={layout.layoutType === 4 ? true : false}
                                onChange={event => {
                                    setLayout({ ...layout, layoutType: 4 })
                                }}
                            >
                                <img className="layout-image" src={slider_layout}></img>
                                <span className="d-flex justify-content-left ml-2">Slider Layout</span>
                            </CustomInput>
                        </div>
                        <div className="col-md-4 my-1">
                            <CustomInput
                                type="radio"
                                name='displayRule'
                                checked={layout.layoutType === 5 ? true : false}
                                onChange={event => {
                                    setLayout({ ...layout, layoutType: 5 })
                                }}
                            >
                                <img className="layout-image" src={slideshow_layout}></img>
                                <span className="d-flex justify-content-left ml-2">SlideShow Layout</span>
                            </CustomInput>
                        </div>
                        <div className="col-md-4 my-1">
                            <CustomInput
                                type="radio"
                                name='displayRule'
                                checked={layout.layoutType === 6 ? true : false}
                                onChange={event => {
                                    setLayout({ ...layout, layoutType: 6 })
                                }}
                            >
                                <img className="layout-image" src={paranoma_layout}></img>
                                <span className="d-flex justify-content-left ml-2">Panorama Layout</span>
                            </CustomInput>
                        </div>
                        <div className="col-md-4 my-1">
                            <CustomInput
                                type="radio"
                                name='displayRule'
                                checked={layout.layoutType === 7 ? true : false}
                                onChange={event => {
                                    setLayout({ ...layout, layoutType: 7 })
                                }}
                            >
                                <img className="layout-image" src={column_layout}></img>
                                <span className="d-flex justify-content-left ml-2">Column Layout</span>
                            </CustomInput>
                        </div>
                        <div className="col-md-4 my-1">
                            <CustomInput
                                type="radio"
                                name='displayRule'
                                checked={layout.layoutType === -1 ? true : false}
                                onChange={event => {
                                    setLayout({ ...layout, layoutType: -1 })
                                }}
                            >
                                <img className="layout-image" src={pro_layout}></img>
                                <span className="d-flex justify-content-left ml-2">Pro Layout</span>
                            </CustomInput>
                        </div>
                        <div className="col-md-4 my-1">
                            <CustomInput
                                type="radio"
                                name='displayRule'
                                checked={layout.layoutType === 8 ? true : false}
                                onChange={event => {
                                    setLayout({ ...layout, layoutType: 8 })
                                }}
                            >
                                <img className="layout-image" src={custom_layout}></img>
                                <span className="d-flex justify-content-left ml-2">Custom Layout</span>
                            </CustomInput>
                        </div>
                        <div className="col-md-4 my-1">
                            <CustomInput
                                type="radio"
                                name='displayRule'
                                checked={layout.layoutType === 9 ? true : false}
                                onChange={event => {
                                    setLayout({ ...layout, layoutType: 9 })
                                }}
                            >
                                <img className="layout-image" src={mobile_layout}></img>
                                <span className="d-flex justify-content-left ml-2">PWA Configurable Layout</span>
                            </CustomInput>
                        </div>
                        <div className="col-md-4 my-1">
                            <CustomInput
                                type="radio"
                                name='displayRule'
                                checked={layout.layoutType === 10 ? true : false}
                                onChange={event => {
                                    setLayout({ ...layout, layoutType: 10 })
                                }}
                            >
                                <img className="layout-image" src={mobile_layout}></img>
                                <span className="d-flex justify-content-left ml-2">PWA Collections Layout</span>
                            </CustomInput>
                        </div>

                    </div>
                    <Separator className="mt-2 mb-2" />
                    <div className="text-center mt-4 mb-3">
                        <Button onClick={handleSave} size="xs" color='primary'>
                            Save
                        </Button>
                        <Button color='secondary' size="xs" onClick={handleBack} className='ml-2'>
                            Reset
                        </Button>
                    </div>
                </CardBody>
            </Card >
        </Fragment >
    );
}
export default StandaloneLayout;
